<script>
  let cols = ['Description', 'Hours', 'Ceil', 'Misc', 'Quantity', 'Price', 'Total'];

  export let invoice = {elements: []};

</script>
<div>
    Number: {invoice.number}
</div>
<table class="table">
    <thead>
    <tr>
        {#each cols as col}
            <th scope="col">{col}</th>
        {/each}
    </tr>
    </thead>
    <tbody>
    {#each invoice.elements as element}
        <tr>
            {#each cols as col}
                <td>
                    {element[col]}
                </td>
            {/each}
        </tr>
    {/each}
    </tbody>
    <tfoot>
    <tr>
        <th></th>
        <th>{invoice.elements.reduce((t, e) => t + e.Hours, 0)}</th>
        <th>{invoice.elements.reduce((t, e) => t + e.Ceil, 0)}</th>
        <th>{invoice.elements.reduce((t, e) => t + e.Misc, 0)}</th>
        <th>{invoice.elements.reduce((t, e) => t + e.Quantity, 0)}</th>
        <th>Subtotal</th>
        <th>{invoice.subtotal}</th>
    </tr>
    <tr>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <td>IRPF ({Math.round(invoice.IRPF * 100)}%)</td>
        <td>{invoice.irpf}</td>
    </tr>
    <tr>
        <td>Misc</td>
        <td>{invoice.misc}</td>
        <th></th>
        <th></th>
        <th></th>
        <td>VAT ({Math.round(invoice.VAT * 100)}%)</td>
        <td>{invoice.vat}</td>
    </tr>
    <tr>
        <td>Global Hours</td>
        <td>{invoice.globalHours}</td>
        <th></th>
        <th></th>
        <th></th>
        <th>Total</th>
        <th>{invoice.total}</th>
    </tr>
    </tfoot>
</table>
